<script>
import { ArrowUpIcon, HeartIcon, EyeIcon, ShoppingCartIcon } from "vue-feather-icons";
import { Carousel, Slide } from "vue-carousel";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import Navbar from "@/view/front/components/navbar";
import Footer from "@/view/front/components/footer";
import CourseFilter from "@/view/front/components/course_filter";
// import Course from "@/view/front/components/course";
import axios from "axios";
// import Swal from "sweetalert2";
import API from "@/core/api";
import { API_URL } from "@/core/api";
import IndexService from "@/MainServices/IndexService.js";
// import Skeleton from "@/view/front/components/skeleton";

/**
 * Shop-product-detail component
 */
export default {
  data() {
    return {
      countval: 1,
      API: API.API_HOME,
      uni_name: this.$route.params.uni_name,
      uni_id: this.$route.params.uni_id,
      courses: [],
      loading:true,
      token: `Bearer ${localStorage.getItem("token")}`,
      university: [],
      campuses_cities: "",
      Programs_offered: "",
      campuses: "",
    };
  },
  components: {
    Navbar,
    CourseFilter,
    Footer,
    ArrowUpIcon,
  },
  methods: {
    onImageLoadFailure(event) {
      event.target.src = "/images/uni_demo_profile.png";
    },
  },
  mounted() {
    IndexService.getUniCourse(
      this.uni_name,
    ).then((response) => {
      this.courses = response.data;
       this.loading = false;
    });

    IndexService.getSingleUniversity(this.uni_id).then((response) => {
      this.university = response.data;
     for (let i = 0; i < this.university.campuses.length; i++) {

       if(i == this.university.campuses.length - 1){
          this.campuses_cities += this.university.campuses[i].city.city;
          this.campuses += this.university.campuses[i].name;
       }else {
          this.campuses_cities += this.university.campuses[i].city.city +", ";
          this.campuses += this.university.campuses[i].name +", ";
       }
       

       for (let j = 0; j < this.university.campuses[i].listings.length; j++) {

         if(j === this.university.campuses[i].listings.length - 1) {
           this.Programs_offered += this.university.campuses[i].listings[j].title;
         }
         else {
           this.Programs_offered += this.university.campuses[i].listings[j].title +", ";
         }
         
       }
       
     }
      this.loading = false;
    });
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="d-table w-100">
      <div class="main_top_uni_courses_page_bg_hero">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12 text-center">
              <div class="r_main_uni_courses_uniname_div">
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="r_sub_left_uni_course_unilogo_div">
                      <div class="r_sub_left_uni_course_unilogo_div_img">
                        <img class="r_sub_left_uni_course_unilogo"
                          @error="onImageLoadFailure($event)"
                          :src="API + `${university.profile.image_path}` || ''">
                      </div>
                      <button class="btn btn-success r_sub_left_uni_course_uni_v_m_b"><a href="#r_uni__course_filter_sec_main" class="text-white">View degree programs</a> </button>
                      <button class="btn btn-secondary r_sub_left_uni_course_uni_d_p_b">Departments</button>
                      <div class="d-flex justify-content-between">
                        <button class="btn btn-light r_sub_left_uni_course_uni_v_m_b">Campuses</button>
                        <button class="btn btn-light r_sub_left_uni_course_uni_d_b">Disciplines</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-8 col-md-8 col-sm-12 pt-0">
                    <div class="r_sub_right_uni_course_unidesc_div">
                      <h1 class="r_sub_right_uni_course_uniname">{{ university.name }}</h1>
                      <p class="r_sub_right_uni_course_uniname">Programs offered by <span style="color: #2eca8b;"> {{ university.name }} </span>
                        apply in courses or view admission details
                      </p>
                      <div class="badge badge-warning r_sub_right_uni_course_unibadge">
                        <img src="/images/myuni/uni_courses/PNG/hec.png" style="width:85%">
                        <!-- <i class="mdi mdi-star-outline"></i> HEC recognized -->
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div class="page-next"></div>
            </div>
          </div>
          <!--end row-->
        </div>
        <!--end container-->
      </div>
    </section>
    <!--end section-->
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!-- Hero End -->

    <!-- Details section start -->
    <section class="r_dets_sec_uni_courses_page" id="institute_details">
      <div class="row r_dets_sec_uni_courses_page_main_row_div">
        <div class="col-lg-4 col-md-12 pl-0 pt-0 pb-0">
          <div class="r_dets_sec_uni_courses_page_left_div" >
            <h4 class="r_dets_sec_uni_courses_page_left_div_h">Institute name:</h4>
            <p class="r_dets_sec_uni_courses_page_left_div_p">{{ university.name }}</p>
            <h4 class="r_dets_sec_uni_courses_page_left_div_h">Campuses in Cities:</h4>
            <p class="r_dets_sec_uni_courses_page_left_div_p">{{campuses_cities}}</p>
            <h4 class="r_dets_sec_uni_courses_page_left_div_h">Campuses:</h4>
            <p class="r_dets_sec_uni_courses_page_left_div_p">{{campuses}}</p>
            
            <h4 class="r_dets_sec_uni_courses_page_left_div_h">Scholarships Available:</h4>
            <p class="r_dets_sec_uni_courses_page_left_div_p">No</p>
            <h4 class="r_dets_sec_uni_courses_page_left_div_h">Contact no:</h4>
            <p class="r_dets_sec_uni_courses_page_left_div_p">{{university.contact}}</p>
          </div>
        </div>
        <div class="col-lg-8 col-md-12 r_dets_sec_uni_courses_page_right_div">
          <h4 class="r_dets_sec_uni_courses_page_right_div_h">Introduction</h4>
          <p class="r_dets_sec_uni_courses_page_right_div_p">{{ university.introduction }}</p>
          <h4 class="r_dets_sec_uni_courses_page_left_div_h">Programs offered:</h4>
          <p class="r_dets_sec_uni_courses_page_left_div_p">{{Programs_offered}}</p>
          <!-- <a href="#" class="r_dets_sec_uni_courses_page_right_div_cont-r">Continue reading...</a> -->
        </div>
      </div>
    </section>
    <!-- Details section start ends -->


    <!-- search courses section -->
    <section class="r_uni__course_filter_sec_main" id="r_uni__course_filter_sec_main">
      <div class="r_uni__course_filter_sec_maindiv1">
        <h2 class="r_uni__course_filter_sec_maindiv1_h2">Courses and programs offered by</h2>
        <h4 class="r_uni__course_filter_sec_maindiv1_h4">{{ university.name }}</h4>
      </div>
      <CourseFilter />
    </section>
    <!-- search courses section ends -->
    <!--end section-->
    <!--end section-->
    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style>
.r-c-search-page-cont-sec {
    padding: 0 5rem !important;
}
</style>
